import { useQuery } from '@tanstack/react-query'
import { useAtom } from 'jotai'
import { safeSearchAtom } from '@!/atoms/safeSearchAtom'
import { searchApi } from '@!/Api/search'
import { searchKeys } from '@!/Api/queryKeys'

export function useSearch(type, searchTerm, page, options) {
  const [safeSearch] = useAtom(safeSearchAtom)

  return useQuery({
    queryKey: searchKeys.search(type, searchTerm, page, safeSearch, options),
    queryFn: () => searchApi(type, searchTerm, page, safeSearch, options),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  })
}
